import { render, staticRenderFns } from "./base-input-slider.vue?vue&type=template&id=3a9c9f44&scoped=true"
import script from "./base-input-slider.vue?vue&type=script&lang=ts"
export * from "./base-input-slider.vue?vue&type=script&lang=ts"
import style0 from "./base-input-slider.vue?vue&type=style&index=0&id=3a9c9f44&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9c9f44",
  null
  
)

export default component.exports